<template>
        <v-btn
            color="primary"
            tile
            large
            class="px-3 navigation-button"
            v-if="externalURL"
            :href="externalURL"
            target="_blank"
        >
            {{ text }}
        </v-btn>

        <router-link :to="slug" v-else>
            <v-btn
                color="primary"
                tile
                large
                class="px-3 navigation-button"
            >
                {{ text }}
            </v-btn>
        </router-link>
</template>

<script>
export default {
    name: 'NavigationButton',
    props: {
        /**
         * The slug of the URL that should be used
         * for internal navigation.
         */
        slug: String,
        /**
         * The content of the button.
         */
        text: String,
        /**
         * External link that should be used for
         * external navigation
         */
        externalURL: String
    }
}
</script>

<style scoped>
.navigation-button {
    border-radius: 50px;
    box-shadow: inset 0 0 0 0 black;
	-webkit-transition: all ease 0.8s;
	-moz-transition: all ease 0.8s;
    transition: all ease 0.8s;
} 

.navigation-button:hover {
    box-shadow: inset 200px 0px 0px 0px black;
    font-weight: bolder;
    background-color: #00B1C3;
    border: 1px solid black;
}
</style>